import { getAllPermission } from 'src/app/core/utils/common-functions';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageResp } from 'src/app/core/models/page/page-response';
import { MergeKeyDetailResult } from 'src/app/core/models/transport-operation/merge-key-detail-result';
import { MergeKeySearechResult } from 'src/app/core/models/transport-operation/merge-key-searech-result';
import { QueryMergeKeyRequest } from 'src/app/core/models/transport-operation/query-merge-key-request';
import { environment } from 'src/environments/environment';
import { MergedDeliveryOrderRequest } from 'src/app/core/models/transport-operation/merged-delivery-order-request';
import { MergedDeliveryOrderResult } from 'src/app/core/models/transport-operation/merged-delivery-order-result';
import { MergeKeyDetailAdditionRequest } from 'src/app/core/models/transport-operation/merge-key-detail-addition-request';
import { MergeKeyDeleteRequest } from 'src/app/core/models/transport-operation/merge-key-delete-request';
import { MergeKeyCreationRequest } from 'src/app/core/models/transport-operation/merge-key-creation-request';
import { MergeKeyCreationResp } from 'src/app/core/models/transport-operation/merge-key-creation-resp';
import { MergeKeyConfirmationCancelRequest } from 'src/app/core/models/transport-operation/merge-key-confirmation-cancel-request';
import { MergeKeyConfirmationRequest } from 'src/app/core/models/transport-operation/merge-key-confirmation-request';
import { MergeKeyConfirmationResp } from 'src/app/core/models/transport-operation/merge-key-confirmation-resp';
import { InstantBookingRequest } from 'src/app/core/models/transport-operation/instant-booking-request';
import { InstantBookingResponse } from 'src/app/core/models/transport-operation/instant-booking-response';
import { CheckAllDoInMergeKeyResponse } from 'src/app/core/models/transport-operation/check-all-do-in-mergekey-response';
import { ChangeMergeKeyMixFacilityResponse } from 'src/app/core/models/transport-operation/change-merge-key-mixfacility-response';
import { ChangeMergeKeyMixFacilityRequest } from 'src/app/core/models/transport-operation/change-merge-key-mixfaility-request';
import { MergekeyDetailDeleteResp } from 'src/app/core/models/transport-operation/merge-key-detail-delete-resp';
import { MergeBlockDetailResult } from 'src/app/core/models/transport-operation/merge-block-detail-result';
import { CancelDeliveryOrderMergeRequest } from 'src/app/core/models/transport-operation/cancel-delivery-order-merge-request';
import { CancelMergeKeyRequest } from 'src/app/core/models/transport-operation/cancel-merge-key-request';

@Injectable({
  providedIn: 'root'
})
export class MergeKeyService {

  constructor(
    private http: HttpClient
  ) {

  }

  queryMergeKey(params: QueryMergeKeyRequest): Observable<PageResp<MergeKeySearechResult>>{
    const url = `${environment.logisticsApiUrl}/merge/mergeKey`;
    return this.http.post<PageResp<MergeKeySearechResult>>(url, params);
  }

  getMergeKeyDetail(mergeKey: string): Observable<MergeKeyDetailResult[]>{
    const url = `${environment.logisticsApiUrl}/merge/mergeKeyDetail/${mergeKey}`;
    return this.http.get<MergeKeyDetailResult[]>(url);
  }

  deleteMergeKeyDetail(mergeKey: string | null, doNo: string | null): Observable<MergekeyDetailDeleteResp>{
    const url = `${environment.logisticsApiUrl}/merge/mergeKeyDetailDelete/${mergeKey}/${doNo}`;
    return this.http.delete<MergekeyDetailDeleteResp>(url);
  }

  queryMergedDeliveryOrder(params: MergedDeliveryOrderRequest): Observable<PageResp<MergedDeliveryOrderResult>>{
    const url = `${environment.logisticsApiUrl}/merge/mergeDeliveryOrder`;
    return this.http.post<PageResp<MergedDeliveryOrderResult>>(url, params);
  }

  getMergeBlockDetail(doNo: string): Observable<MergeBlockDetailResult>{
    const url = `${environment.logisticsApiUrl}/merge/mergeBlockDetail/${doNo}`;
    return this.http.get<MergeBlockDetailResult>(url);
  }

  mergeKeyDetailAddition(params: MergeKeyDetailAdditionRequest): Observable<void>{
    const url = `${environment.logisticsApiUrl}/merge/mergeKeyDetailAddition`;
    return this.http.post<void>(url, params);
  }

  mergeKeyDelete(params: MergeKeyDeleteRequest): Observable<void>{
    const url = `${environment.logisticsApiUrl}/merge/mergeKeyDelete`;
    return this.http.post<void>(url, params);
  }

  mergeKeyCreation(params: MergeKeyCreationRequest): Observable<MergeKeyCreationResp>{
    const url = `${environment.logisticsApiUrl}/merge/mergeKeyCreation`;
    return this.http.post<MergeKeyCreationResp>(url, params);
  }

  mergeKeyConfirmationWithdraw(params: MergeKeyConfirmationCancelRequest): Observable<void>{
    const url = `${environment.logisticsApiUrl}/merge/mergeKeyConfirmationWithdraw`;
    return this.http.put<void>(url, params);
  }

  mergeKeyConfirmation(params: MergeKeyConfirmationRequest): Observable<MergeKeyConfirmationResp>{
    const url = `${environment.logisticsApiUrl}/merge/mergeKeyConfirmation`;
    return this.http.post<MergeKeyConfirmationResp>(url, params);
  }

  instantBooking(param: InstantBookingRequest): Observable<InstantBookingResponse>{
    const url = `${environment.logisticsApiUrl}/merge/instantBooking`;
    return this.http.post<InstantBookingResponse>(url, param);
  }

  checkAllDoInMergeKey(param: string): Observable<CheckAllDoInMergeKeyResponse> {
    const url = `${environment.logisticsApiUrl}/merge/checkAllDoInMergeKey/${param}`;
    return this.http.get<CheckAllDoInMergeKeyResponse>(url);
  }

  changeMixFaility(param: ChangeMergeKeyMixFacilityRequest): Observable<ChangeMergeKeyMixFacilityResponse[]> {
    const url = `${environment.logisticsApiUrl}/merge/changeMergeKeyMixFacility`
    return this.http.put<ChangeMergeKeyMixFacilityResponse[]>(url, param);
  }

  updateMixFacilityByAdmin(param: ChangeMergeKeyMixFacilityRequest): Observable<void> {
    const url = `${environment.logisticsApiUrl}/merge/updateMixFacilityByAdmin`;
    return this.http.put<void>(url, param);
  }

  cancelDeliveryOrderMerge(param: CancelDeliveryOrderMergeRequest): Observable<void> {
    const url = `${environment.logisticsApiUrl}/merge/cancelDeliveryOrderMerge`;
    return this.http.put<void>(url, param);
  }

  cancelMergeKey(param: CancelMergeKeyRequest): Observable<void> {
    const url = `${environment.logisticsApiUrl}/merge/cancelMergeKey`;
    return this.http.put<void>(url, param);
  }
}
